import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

const DEFAULT_INTL_TEL_COUNTRY = 'us';

// locations.country is free-text; map common aliases to ISO2 for intl-tel-input.
const COUNTRY_ALIASES = {
  us: 'us',
  usa: 'us',
  'u.s': 'us',
  'u.s.': 'us',
  'u.s.a': 'us',
  'u.s.a.': 'us',
  'united states': 'us',
  'united states of america': 'us',
  ca: 'ca',
  canada: 'ca',
  sg: 'sg',
  singapore: 'sg',
};

export function parsePhone(rawValue, iso2) {
  const value = (rawValue || '').trim();
  if (!value) return null;
  return parsePhoneNumberFromString(value, iso2 ? iso2.toUpperCase() : undefined);
}

export function isValidPhone(rawValue, iso2) {
  const phone = parsePhone(rawValue, iso2);
  return !!phone && phone.isValid();
}

/**
 * Resolve a free-text location country into an ISO2 code intl-tel-input accepts.
 * Unknown / non-ISO2 values fall back to `us` so page setup cannot throw.
 */
export function resolveIntlTelInputCountry(
  rawCountry,
  knownIso2Codes,
  fallback = DEFAULT_INTL_TEL_COUNTRY,
) {
  if (rawCountry == null || String(rawCountry).trim() === '') {
    return fallback;
  }

  const normalized = String(rawCountry).trim().toLowerCase().replace(/\s+/g, ' ');
  const withoutDots = normalized.replace(/\./g, '');
  let iso2 = COUNTRY_ALIASES[normalized] || COUNTRY_ALIASES[withoutDots];

  if (!iso2 && /^[a-z]{2}$/.test(normalized)) {
    iso2 = normalized;
  }

  if (!iso2) {
    return fallback;
  }

  if (knownIso2Codes && knownIso2Codes.size > 0 && !knownIso2Codes.has(iso2)) {
    return fallback;
  }

  return iso2;
}
